import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CardItem, RowItem } from '../models';
import { PnrrToolService } from './pnrr-tool.service';
import { ToolType, LEGACY_TOOLS } from 'src/app/resources/tool-utils';

@Injectable({ providedIn: 'root' })

export class NavigateService {

  private old_tools: ToolType[] = LEGACY_TOOLS;

  constructor(private router: Router, private pnrr: PnrrToolService) { }

  async getRouterLink(item: CardItem | RowItem) {
    if (item.type !== 'execution') {
      this.router.navigate([`/${item.type}/${item.id}`]);
    } else {
      const route : any[] = await this.getRouterExecutionURL(item);
      this.router.navigate(route)
    }
  }

  async getRouterExecutionURL( item : {
      id? : string, tool?: string, name : string, type?:string,
      status? : string, sub_status?: string, 
      isAggregationDone?: boolean, isConfigurationDone?: boolean
    }) : Promise<any[]>{


    const _tool : ToolType = (item.tool as ToolType)
    if (item.tool == ToolType.PNRR) {
      let path = await this.pnrr.getUrlForExecution(item.id) as any;
      let p = path ? [path?.path] : null
      if (path?.step !== null && p) p = [...p, { step: path?.step }]
      return p;
    }
    else if(_tool === ToolType.RO){
      return [`/tool/ro-pbi-wrapper`, {idExecution: item.id, executionName: item.name, executionStatus: item.status, isPrevComponentHome: 'false'}];
    }
    else if (item.tool === ToolType.DBT) {
      return [`/execution/${item.id}/data-breach`];
    }
    else if(item.tool === ToolType.PET){
      if(item.status === 'Draft'){
        return[`/${item.type}/${item.id}/edit`];
      }else if(item.status == 'Running' && item.sub_status === 'client-input-uploaded'){
        return [`/${item.type}/${item.id}/PET/validate`]
      }

      else if(item.status === 'Completed'){
        return [`/${item.type}/${item.id}/PET/output`]
      }
    }
    // @Default @Bamba I nuovi tool dovrebbero finire qua
    else if (!this.old_tools.includes(_tool)){
      if(item.status === 'Completed'){
        return [`/${item.type}/${item.id}/${item.tool}/output`]
      }
    }
    switch (item.status) {
      case 'Completed':
        if ((item.tool === ToolType.NLL || item.tool === ToolType.NLS) && !item.isAggregationDone) {
          return [`/execution/${item.id}/portfolio`];
        } else if (item.tool === ToolType.IFRS17_NL && !item.isConfigurationDone) {
          return [`/execution/${item.id}/configurations`];
        } else if(_tool === ToolType.NEWRO){
          return [`/tool/ttd-pbi/${item.id}`, {executionName: item.name, executionStatus: item.status, isPrevComponentHome: 'false'}];
        }
        else {
          return [`/tool/${item.tool}/${item.id}`];
        }
      case 'Draft':
        return [`/${item.type}/${item.id}/edit`];
      case 'Failed':
        break;
      case 'Running':
        return [`/execution/${item.id}/redirect`];//, { queryParams: { status: item.status } });
      default:
        return [`/${item.type}/${item.id}/edit`];
    }
  }
}
